module.exports = __webpack_public_path__ + "static/media/testmonial_01.5ff345cc.png";